// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeReviewes_container__3HTlQ","title":"HomeReviewes_title__3QWcz","list":"HomeReviewes_list__20bsf"};